import React, { useState } from 'react';
import { styled, useTheme } from '@mui/system';
import { Drawer as MuiDrawer, Toolbar, IconButton, Divider, Typography, TextField, Radio, RadioGroup, FormControlLabel, FormControl, Box } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ListStudentPerTeacher from './ListStudentPerTeacher';

const drawerWidth = 280;

const StyledDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: open ? drawerWidth : theme.spacing(7),
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      overflowX: 'hidden',
      [theme.breakpoints.up('sm')]: {
        width: open ? drawerWidth : theme.spacing(9),
      },
    },
  })
);

export default function DrawerTeacher({ open, toggleDrawer}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('active');
  const theme = useTheme();

  const handleSearchQuery = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  return (
    <StyledDrawer variant="permanent" open={open} theme={theme}>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: [1],
          height: '5vh'
        }}
      >
        <IconButton onClick={toggleDrawer}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      <Divider />
      {open && (
        <Box
          sx={{
            display: 'flex', // Flexbox 활성화
            flexDirection: 'column', // 요소를 세로 방향으로 배치
            justifyContent: 'center', // 수직 가운데 정렬
            height: '15vh', 
            overflow: 'hidden',
          }}
        >
          <FormControl component="fieldset">
            <TextField
              sx={{ m: 2 }}
              id="search-field"
              label="Search Name"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={handleSearchQuery}
            />
            <RadioGroup row value={statusFilter} onChange={handleStatusChange} sx={{ display: 'flex', mx: 2 }}>
              <FormControlLabel value="active" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '0.6rem' }}>Active</Typography>} />
              <FormControlLabel value="inactive" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '0.6rem' }}>Inactive</Typography>} />
              <FormControlLabel value="all" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '0.6rem' }}>All</Typography>} />
            </RadioGroup>
          </FormControl>
        </Box>
      )}
      <ListStudentPerTeacher
        searchQuery={searchQuery}
        statusFilter={statusFilter}
      />
    </StyledDrawer>
  );
}
